import { BffInterfacesBasket } from '@dfds-pax/booking-experience-bff'

import { PassengerCategory } from '@/components/summary/interfaces'

import { Step, StepType } from '../steps'

export const ToPassengerCategory = (passengers: BffInterfacesBasket.Passenger[]) => {
  const PassengerCategories: PassengerCategory[] = []
  PassengerCategories.push({ quantity: passengers.filter((p) => p.categoryCode === 'Adult').length, type: 'Adult' })
  if (passengers.some((p) => p.categoryCode === 'Child'))
    PassengerCategories.push({
      ages: passengers.filter((p) => p.categoryCode === 'Child').length
        ? passengers.filter((p) => p.categoryCode === 'Child').map((c) => c.age)
        : [],
      quantity: passengers.filter((p) => p.categoryCode === 'Child').length,
      type: 'Child',
    })
  if (passengers.some((p) => p.categoryCode === 'Infant'))
    PassengerCategories.push({
      ages: passengers.filter((p) => p.categoryCode === 'Infant').length
        ? passengers.filter((p) => p.categoryCode === 'Infant').map((c) => c.age)
        : [],
      quantity: passengers.filter((p) => p.categoryCode === 'Infant').length,
      type: 'Infant',
    })
  return PassengerCategories
}

export const isStepInactive = (stepType: StepType, currentIndex: number, stepIndex: number, basket: BffInterfacesBasket.Basket) => {
  if (currentIndex === stepIndex) {
    return true
  }
  const isFutureStep = currentIndex < stepIndex + 1

  // Matches the new summary: details the user already entered stay visible when they navigate back.
  const selectedPassengers =
    basket.passengers && basket.passengers.length > 0 && basket.passengers.filter((p) => p.firstName && p.lastName).length > 0
  if (stepType === 'DEPARTURES') {
    const selectedDepartures = basket.departures && basket.departures.length > 0
    if (isFutureStep && !selectedDepartures) {
      return true
    }
  }
  if (stepType === 'PETS') {
    const selectedPets = basket.departures[0]?.pets && basket.departures[0]?.pets.length > 0

    if (isFutureStep && !selectedPets && !selectedPassengers) {
      return true
    }
  }
  if (stepType === 'EXTRAS') {
    const selectedExtras = basket.departures[0]?.addons && basket.departures[0]?.addons.length > 0
    if (isFutureStep && !selectedExtras && !selectedPassengers) {
      return true
    }
  }
  if (stepType === 'PASSENGERS') {
    if (isFutureStep && !selectedPassengers) {
      return true
    }
  }
  if (stepType === 'CHECKOUT') {
    const selectedCheckout = basket.customer || basket.paymentMethod
    if (isFutureStep && !selectedCheckout) {
      return true
    }
  }
  if (stepType === 'REVIEW') {
    if (isFutureStep) {
      return true
    }
  }

  return false
}

const supportedSteps: Step[] = [
  { resourceKey: 'MY-SEARCH-PAGE', stepType: 'TRAVEL' },
  { resourceKey: 'DEPARTURES-PAGE', stepType: 'DEPARTURES' },
  { resourceKey: 'PETS-PAGE', stepType: 'PETS' },
  { resourceKey: 'EXTRAS-PAGE', stepType: 'EXTRAS' },
  { resourceKey: 'PASSENGERS-PAGE', stepType: 'PASSENGERS' },
  { resourceKey: 'CHECKOUT-PAGE', stepType: 'CHECKOUT' },
  { resourceKey: 'REVIEW-AND-PAY-PAGE', stepType: 'REVIEW' },
]

export const getSteps = (numberOfPets: number) => {
  return supportedSteps.filter((s) => {
    if (numberOfPets === 0 && s.stepType === 'PETS') return false
    return true
  })
}
